import styled, { keyframes } from 'styled-components';

import { Box, Text } from '@gympass/yoga';

import { patientsModalWidth } from 'modals/ChatListModal/styles';

const emptyChatAnimation = keyframes`
 0% { opacity: 0; }
 100% { opacity: 1; }
`;

// Duplicated keyframe animation in order to always trigger on classes toggle
// Animations should be different in order to trigger
const patientsModeAnimation = keyframes`
 0% { opacity: 0; }
 99% { opacity: 1; }
`;

export const ChatConversationRoot = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% - ${patientsModalWidth}px);
  background-color: ${({ theme }) => theme.yoga.colors.backgroundLight};
  position: relative;

  & .empty-chat {
    animation-duration: 0.8s;
    animation-name: ${emptyChatAnimation};
  }

  & .patients-mode {
    animation-duration: 0.8s;
    animation-name: ${patientsModeAnimation};
  }

  @media screen and (max-width: 1024px) {
    width: 100%;
    height: 100%;
  }
`;

export const EmptyChatContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 50%;
  img {
    max-width: 207px;
  }
`;

export const EmptyChatText = styled(Text.H5)`
  font-weight: 300;
  text-align: center;
  margin-top: ${({ theme }) => theme.yoga.spacing.xlarge}px;
  margin-bottom: ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const ConversationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;
